const awTitle = {
  workDone: [
      'Converted Adobe XD design into a functional website',
      'Developed in Embedded Ruby and worked on the dev standards team',
      'Created Responsive design by following the mobile-first approach and implemented BEM methodology',
      'Developed site-wide search using Algolia and Ruby on Rails by querying controllers to retrieve data, integrated an autocomplete and predictive search feature, and incorporated debounce functionality to optimize server requests, resulting in improved user experience and 50% faster data retrieval.',
  ],
  tech: [
      'Ruby on Rails',
      'MS SQL',
      'Algolia',
      'SASS',
      'GSAP', 
      'VWO',
      'jQuery', 
      'AWS',
      'Nginx',
      'Adobe XD',
      'Mobile Responsive',
  ],
  liveLink: 'https://www.ashtonwoods.com/',
  features : [
      {
          title: 'Home',
          image: { link: require('./awTitleAssests/Home.png').default }
      },
      {
          title: 'About Us',
          image: { link: require('./awTitleAssests/About-Us.png').default }
      },
      {
          title: 'Locations',
          image: { link: require('./awTitleAssests/Locations.png').default }
      },
      {
          title: 'Contact Us',
          image: { link: require('./awTitleAssests/Contact-Us.png').default }
      },
      {
          title: 'Disclaimer',
          image: { link: require('./awTitleAssests/Disclaimer.png').default }
      },
      {
          title: 'Site Map',
          image: { link: require('./awTitleAssests/Site-Map.png').default }
      },
  ],
}

export default awTitle